<template>
  <v-sheet height="100vh" width="100%" color="transparent" class="d-flex align-center justify-center">
    <v-sheet height="100vh" width="400px" color="transparent" class="d-flex align-center justify-center">
      <v-card class="rounded-xl text-center px-4 py-12  overflow-auto" max-height="80%">
        <v-avatar :size="164" color="grey lighten-5" class="ma-1">
          <v-img :src="logoUrl" :lazy-src="''">
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-avatar>
        <v-card-title class="justify-center">{{ route }}</v-card-title>
        <signinForm v-if="route === 'Anmelden'"></signinForm>
        <signupForm v-if="route === 'Registrieren'"></signupForm>
        <updatePasswordForm v-if="route === 'Passwort vergessen'"></updatePasswordForm>
      </v-card>
    </v-sheet>
  </v-sheet>
</template>

<script>
  import signinForm from './SigninForm'
  import signupForm from './SignupForm'
  import updatePasswordForm from './updatePasswordForm'
  export default {
    components: {
      signinForm,
      signupForm,
      updatePasswordForm
    },
    data () {
      return {
        logoUrl: null
      }
    },
    mounted () {
      this.loadLogo()
    },
    computed: {
      route () {
        return this.$route.name
      }
    },
    methods: {
      async loadLogo () {
        try {
          const url = await this.logoImage()
          this.logoUrl = url
        } catch (error) {
          console.error('Error loading logo:', error)
        }
      },
      async logoImage () {
        try {
          const storagePath = `/design/logo/${this.$vars.verbindung}`
          const url = await this.$firebase.storage().ref(storagePath).getDownloadURL()
          return url
        } catch (error) {
          console.error(error)
          throw error // Rethrow the error to be caught in the calling function
        }
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// SigninCard.vue?09dc28c4